<script setup lang="ts">
defineProps<{
  value?: string | number
}>()

const i18n = useI18n()
const locale = i18n.t('language.locale')
const format = makeNumberFormat(i18n.t('language.currency'))
</script>

<template>
  {{
    i18n.n(
      parseFloat(value && value.toString ? value.toString() : '0') / 100,
      // @ts-ignore
      format.percent,
      locale,
    )
  }}
</template>
